import { CONFIG, LogLevel } from '@frameio/config';

const CONSOLE_STYLES =
  'background-color: rgba(91, 83, 255, 1); border-radius: 24px; color: rgba(255,255,255,1); font-weight: 800; padding: 0 8px; font-size: 12px;';
const CONSOLE_PILL_PREFIX = ['%cFrame.io Developer', CONSOLE_STYLES];

export const log = {
  error(...args: Parameters<typeof console.error>) {
    if (CONFIG.logLevel >= LogLevel.ERROR) {
      // eslint-disable-next-line no-console
      console?.error?.(...[...CONSOLE_PILL_PREFIX, ...args]);
    }
  },
  warn(...args: Parameters<typeof console.warn>) {
    if (CONFIG.logLevel >= LogLevel.WARN) {
      // eslint-disable-next-line no-console
      console?.warn?.(...[...CONSOLE_PILL_PREFIX, ...args]);
    }
  },
  info(...args: Parameters<typeof console.info>) {
    if (CONFIG.logLevel >= LogLevel.INFO) {
      // eslint-disable-next-line no-console
      console?.info?.(...[...CONSOLE_PILL_PREFIX, ...args]);
    }
  },
  table(...args: Parameters<typeof console.table>) {
    if (CONFIG.logLevel >= LogLevel.INFO) {
      // eslint-disable-next-line no-console
      console?.table?.(...args);
    }
  },

  // Uses browser console log level instead of environment log level
  // To see these messages configure your browser Dev Tools to "verbose"
  // https://developer.mozilla.org/en-US/docs/Web/API/console/debug
  debug(...args: Parameters<typeof console.debug>) {
    // eslint-disable-next-line no-console
    console?.debug?.(...args);
  },
};
